<template>
    <div>
        <!-- Hero Header -->
        <!-- <div class="hero-header"></div> -->

        <!-- Preloader -->
        <PagePreloader v-if="!pageIsLoaded"></PagePreloader>

        <!-- <div class="hero-title gutter-b">
            Frequently Asked Questions
        </div> -->

        <!-- NOTE - Announcements -->
        <CustomAnnouncements></CustomAnnouncements>

        <div class="card card-custom gutter-b">
            <div class="card-body">
                <div class="row">
                    <div class="col-xl-4">
                        <ul class="something">
                            <li
                                @click="setPanel('about')"
                                class="lisomething"
                                :class="currentPanel == 'about' ? 'active' : ''"
                            >
                                <a>About Hashtastic</a>
                            </li>
                            <li
                                @click="setPanel('finding')"
                                class="lisomething"
                                :class="currentPanel == 'finding' ? 'active' : ''"
                            >
                                <a>Finding Hashtags</a>
                            </li>
                            <li
                                @click="setPanel('saving')"
                                class="lisomething"
                                :class="currentPanel == 'saving' ? 'active' : ''"
                            >
                                <a>Saving Hashtags</a>
                            </li>
                            <li
                                @click="setPanel('campaigns')"
                                class="lisomething"
                                :class="currentPanel == 'campaigns' ? 'active' : ''"
                            >
                                <a>Hashtag Performance Campaigns</a>
                            </li>
                            <li
                                @click="setPanel('subscription')"
                                class="lisomething"
                                :class="currentPanel == 'subscription' ? 'active' : ''"
                            >
                                <a>My Hashtastic Subscription</a>
                            </li>
                        </ul>
                    </div>
                    <div class="col-xl-8">
                        <!-- About -->
                        <div v-if="currentPanel == 'about'">
                            <div role="tablist">
                                <b-card no-body class="mb-1 border-0">
                                    <b-card-header
                                        header-tag="header"
                                        class="p-1 border-0"
                                        role="tab"
                                    >
                                        <b-button
                                            block
                                            v-b-toggle.accordion-1-1
                                            variant="white"
                                            class="border-0 text-left"
                                        >
                                            <span class="when-opened">
                                                <i class="fas fa-chevron-down text-success"></i>
                                            </span>
                                            <span class="when-closed">
                                                <i class="fas fa-chevron-right text-success"></i>
                                            </span>
                                            <span class="font-weight-bolder">
                                                What is Hashtastic?
                                            </span>
                                        </b-button>
                                    </b-card-header>
                                    <b-collapse
                                        id="accordion-1-1"
                                        visible
                                        accordion="about-accordion"
                                        role="tabpanel"
                                    >
                                        <b-card-body>
                                            <b-card-text>
                                                Hashtastic was born out of frustration. Frustration
                                                that there wasn't anything useful on the market, and
                                                because I felt like my Instagram account was going
                                                nowhere. After months of trial and error I finally
                                                came up with a solution that consistenly delivered
                                                me results, and enabled me to successfully grow my
                                                Instagram accounts using the best hashtag strategy
                                                possible.
                                            </b-card-text>
                                            <b-card-text>
                                                Hashtastic is the most powerful Hashtag scanner in
                                                the game. Packed with useful features, it does all
                                                the leg work for you when selecting hashtags, and
                                                enables you to focus your time on actually growing
                                                your Instagram account.
                                            </b-card-text>
                                        </b-card-body>
                                    </b-collapse>
                                </b-card>

                                <b-card no-body class="mb-1 border-0">
                                    <b-card-header
                                        header-tag="header"
                                        class="p-1 border-0"
                                        role="tab"
                                    >
                                        <b-button
                                            block
                                            v-b-toggle.accordion-1-2
                                            variant="white"
                                            class="border-0 text-left"
                                        >
                                            <span class="when-opened">
                                                <i class="fas fa-chevron-down text-success"></i>
                                            </span>
                                            <span class="when-closed">
                                                <i class="fas fa-chevron-right text-success"></i>
                                            </span>
                                            <span class="font-weight-bolder">
                                                How does Hashtastic work?
                                            </span>
                                        </b-button>
                                    </b-card-header>
                                    <b-collapse
                                        id="accordion-1-2"
                                        accordion="about-accordion"
                                        role="tabpanel"
                                    >
                                        <b-card-body>
                                            <b-card-text>
                                                Hashtastic works by scanning the millions of
                                                hashtags in its database every single day, over and
                                                over again, monitoring the activity and evolution of
                                                metrics such as: number of daily posts, amount of
                                                likes, amount of comments. This means that
                                                Hashtastic is doing all of the leg work for you,
                                                enabling you to focus on more important things, and
                                                make analytics driven decisions.
                                            </b-card-text>
                                        </b-card-body>
                                    </b-collapse>
                                </b-card>

                                <b-card no-body class="mb-1 border-0">
                                    <b-card-header
                                        header-tag="header"
                                        class="p-1 border-0"
                                        role="tab"
                                    >
                                        <b-button
                                            block
                                            v-b-toggle.accordion-1-3
                                            variant="white"
                                            class="border-0 text-left"
                                        >
                                            <span class="when-opened">
                                                <i class="fas fa-chevron-down text-success"></i>
                                            </span>
                                            <span class="when-closed">
                                                <i class="fas fa-chevron-right text-success"></i>
                                            </span>
                                            <span class="font-weight-bolder">
                                                How accurate is Hashtastic?
                                            </span>
                                        </b-button>
                                    </b-card-header>
                                    <b-collapse
                                        id="accordion-1-3"
                                        accordion="about-accordion"
                                        role="tabpanel"
                                    >
                                        <b-card-body>
                                            <b-card-text>
                                                Most Hashtag Apps use a model where they scan a
                                                hashtag once and then forget about it. Hashtastic
                                                does the exact opposite.
                                            </b-card-text>
                                            <b-card-text>
                                                Imagine you're trying to guess how long a runner was
                                                going to take to run a marathon. Most Hashtag Apps
                                                take a look at his starting speed and then try and
                                                guess-timate how long he will take to complete the
                                                marathon based on the first 5 seconds of the race.
                                                This is far from accurate;
                                            </b-card-text>
                                            <b-card-text>
                                                <span class="text-success font-weight-bolder"
                                                    >Hashtastic takes a different approach</span
                                                >
                                                and measures the last 100 races of that runner, how
                                                he feels on the day, weather conditions and uses
                                                mathematics to determine exactly how well he's going
                                                to perform. In the case of hashtags, this means
                                                scanning the same hashtags over and over, every
                                                single day, to ensure that the data is reliable,
                                                accurate, and up-to-date on the day.
                                            </b-card-text>
                                            <b-card-text>
                                                The accuracy of our data is our primary concern, and
                                                is the reason why our users experience incredible
                                                growth on Instagram by leveraging our tools.
                                            </b-card-text>
                                        </b-card-body>
                                    </b-collapse>
                                </b-card>

                                <b-card no-body class="mb-1 border-0">
                                    <b-card-header
                                        header-tag="header"
                                        class="p-1 border-0"
                                        role="tab"
                                    >
                                        <b-button
                                            block
                                            v-b-toggle.accordion-1-4
                                            variant="white"
                                            class="border-0 text-left"
                                        >
                                            <span class="when-opened">
                                                <i class="fas fa-chevron-down text-success"></i>
                                            </span>
                                            <span class="when-closed">
                                                <i class="fas fa-chevron-right text-success"></i>
                                            </span>
                                            <span class="font-weight-bolder">
                                                Is Hashtastic safe?
                                            </span>
                                        </b-button>
                                    </b-card-header>
                                    <b-collapse
                                        id="accordion-1-4"
                                        accordion="about-accordion"
                                        role="tabpanel"
                                    >
                                        <b-card-body>
                                            <b-card-text>
                                                <span class="text-success font-weight-bolder"
                                                    >Yes!</span
                                                >
                                                Hashtastic doesn't store any of your user data,
                                                doesn't log in to your account, and doesn't break
                                                any of Instagram's rules.
                                            </b-card-text>
                                        </b-card-body>
                                    </b-collapse>
                                </b-card>

                                <b-card no-body class="mb-1 border-0">
                                    <b-card-header
                                        header-tag="header"
                                        class="p-1 border-0"
                                        role="tab"
                                    >
                                        <b-button
                                            block
                                            v-b-toggle.accordion-1-5
                                            variant="white"
                                            class="border-0 text-left"
                                        >
                                            <span class="when-opened">
                                                <i class="fas fa-chevron-down text-success"></i>
                                            </span>
                                            <span class="when-closed">
                                                <i class="fas fa-chevron-right text-success"></i>
                                            </span>
                                            <span class="font-weight-bolder">
                                                I have an idea for a feature...
                                            </span>
                                        </b-button>
                                    </b-card-header>
                                    <b-collapse
                                        id="accordion-1-5"
                                        accordion="about-accordion"
                                        role="tabpanel"
                                    >
                                        <b-card-body>
                                            <b-card-text>
                                                <span class="text-success font-weight-bolder"
                                                    >Awesome!</span
                                                >
                                                We'd love to hear your thoughts on how we can
                                                improve the service. Get in touch with us using the
                                                <router-link
                                                    to="/support"
                                                    class="text-primary font-weight-bold"
                                                    >Support Page</router-link
                                                >
                                                and we'll get back to you as soon as possible!
                                            </b-card-text>
                                        </b-card-body>
                                    </b-collapse>
                                </b-card>
                            </div>
                        </div>

                        <!-- Finding Hashtags -->
                        <div v-if="currentPanel == 'finding'">
                            <div role="tablist">
                                <b-card no-body class="mb-1 border-0">
                                    <b-card-header
                                        header-tag="header"
                                        class="p-1 border-0"
                                        role="tab"
                                    >
                                        <b-button
                                            block
                                            v-b-toggle.accordion-2-1
                                            variant="white"
                                            class="border-0 text-left"
                                        >
                                            <span class="when-opened">
                                                <i class="fas fa-chevron-down text-success"></i>
                                            </span>
                                            <span class="when-closed">
                                                <i class="fas fa-chevron-right text-success"></i>
                                            </span>
                                            <span class="font-weight-bolder">
                                                How do I find hashtags?
                                            </span>
                                        </b-button>
                                    </b-card-header>
                                    <b-collapse
                                        id="accordion-2-1"
                                        visible
                                        accordion="finding-accordion"
                                        role="tabpanel"
                                    >
                                        <b-card-body>
                                            <b-card-text>
                                                Hashtastic offers a variety of Hashtag Search tools
                                                that you can use:
                                                <ul>
                                                    <li>
                                                        The
                                                        <router-link
                                                            to="/search"
                                                            class="text-primary font-weight-bolder"
                                                        >
                                                            Regular Search Tool
                                                        </router-link>
                                                        - The most powerful Search tool Hashtastic
                                                        has to offer, enabling to quickly filter,
                                                        sort, and manage a multitude of hashtag
                                                        queries at once.
                                                    </li>
                                                    <li>
                                                        The
                                                        <router-link
                                                            to="/bulk"
                                                            class="text-primary font-weight-bolder"
                                                        >
                                                            Bulk Search Tool
                                                        </router-link>
                                                        - Allowing you get advanced analytics on up
                                                        to 200 hashtags at once.
                                                    </li>
                                                    <li>
                                                        The
                                                        <router-link
                                                            to="/relevant"
                                                            class="text-primary font-weight-bolder"
                                                        >
                                                            Relevant Search Tool
                                                        </router-link>
                                                        - Allowing you explore ideas for similar
                                                        hashtags you may not have thought of.
                                                    </li>
                                                </ul>
                                            </b-card-text>
                                        </b-card-body>
                                    </b-collapse>
                                </b-card>

                                <b-card no-body class="mb-1 border-0">
                                    <b-card-header
                                        header-tag="header"
                                        class="p-1 border-0"
                                        role="tab"
                                    >
                                        <b-button
                                            block
                                            v-b-toggle.accordion-2-2
                                            variant="white"
                                            class="border-0 text-left"
                                        >
                                            <span class="when-opened">
                                                <i class="fas fa-chevron-down text-success"></i>
                                            </span>
                                            <span class="when-closed">
                                                <i class="fas fa-chevron-right text-success"></i>
                                            </span>
                                            <span class="font-weight-bolder">
                                                Which are the best hashtags?
                                            </span>
                                        </b-button>
                                    </b-card-header>
                                    <b-collapse
                                        id="accordion-2-2"
                                        accordion="finding-accordion"
                                        role="tabpanel"
                                    >
                                        <b-card-body>
                                            <b-card-text>
                                                <span class="text-success font-weight-bolder"
                                                    >Good hashtags</span
                                                >
                                                are the ones that will enable you to rank highly in
                                                the 'top posts' section of a hashtag. This will
                                                generate more impressions on your posts, which in
                                                turn will generate more likes, which in turn will
                                                generate more new followers.
                                            </b-card-text>
                                            <b-card-text>
                                                In order to reach the 'top posts' section of a
                                                hashtag you need to be stronger than your
                                                competition, this means finding hashtags that:
                                                <ul>
                                                    <li>
                                                        <span class="text-primary font-weight-bold">
                                                            Have a low DAPC and high post count.
                                                        </span>
                                                        This means they have low competition, but
                                                        high popularity
                                                    </li>
                                                    <li>
                                                        Have an
                                                        <span class="text-primary font-weight-bold">
                                                            'Average Number of likes'
                                                        </span>
                                                        similar or lower than what your account has.
                                                        This means you have a better chance of
                                                        overtaking those posts.
                                                    </li>
                                                </ul>
                                            </b-card-text>
                                        </b-card-body>
                                    </b-collapse>
                                </b-card>

                                <b-card no-body class="mb-1 border-0">
                                    <b-card-header
                                        header-tag="header"
                                        class="p-1 border-0"
                                        role="tab"
                                    >
                                        <b-button
                                            block
                                            v-b-toggle.accordion-2-3
                                            variant="white"
                                            class="border-0 text-left"
                                        >
                                            <span class="when-opened">
                                                <i class="fas fa-chevron-down text-success"></i>
                                            </span>
                                            <span class="when-closed">
                                                <i class="fas fa-chevron-right text-success"></i>
                                            </span>
                                            <span class="font-weight-bolder">
                                                What does DAPC stand for?
                                            </span>
                                        </b-button>
                                    </b-card-header>
                                    <b-collapse
                                        id="accordion-2-3"
                                        accordion="finding-accordion"
                                        role="tabpanel"
                                    >
                                        <b-card-body>
                                            <b-card-text>
                                                <span class="text-success font-weight-bolder"
                                                    >DAPC</span
                                                >
                                                stands for Daily Average Post Count. It is the
                                                number of new Instagram posts on a given hashtag per
                                                day.
                                            </b-card-text>
                                            <b-card-text>
                                                The Daily Average Post Count of a Hashtag is a great
                                                indicator of how competitive a Hashtag is. The more
                                                Daily Posts, the more competition, the harder it is
                                                for you to rank highly in the 'top posts' portion of
                                                a hashtag.
                                            </b-card-text>
                                        </b-card-body>
                                    </b-collapse>
                                </b-card>

                                <b-card no-body class="mb-1 border-0">
                                    <b-card-header
                                        header-tag="header"
                                        class="p-1 border-0"
                                        role="tab"
                                    >
                                        <b-button
                                            block
                                            v-b-toggle.accordion-2-4
                                            variant="white"
                                            class="border-0 text-left"
                                        >
                                            <span class="when-opened">
                                                <i class="fas fa-chevron-down text-success"></i>
                                            </span>
                                            <span class="when-closed">
                                                <i class="fas fa-chevron-right text-success"></i>
                                            </span>
                                            <span class="font-weight-bolder">
                                                What is a hashtag's score?
                                            </span>
                                        </b-button>
                                    </b-card-header>
                                    <b-collapse
                                        id="accordion-2-4"
                                        accordion="finding-accordion"
                                        role="tabpanel"
                                    >
                                        <b-card-body>
                                            <b-card-text>
                                                The
                                                <span class="text-success font-weight-bolder"
                                                    >Hashtastic Score</span
                                                >
                                                is an indicator of how effective a Hashtag is going
                                                to be, compared to the other hashtags in your
                                                selection. It is the ratio of the Post Count / DAPC.
                                            </b-card-text>
                                            <b-card-text>
                                                If you're hesitating between two hashtags, pick the
                                                one with the highest score.
                                            </b-card-text>
                                        </b-card-body>
                                    </b-collapse>
                                </b-card>

                                <b-card no-body class="mb-1 border-0">
                                    <b-card-header
                                        header-tag="header"
                                        class="p-1 border-0"
                                        role="tab"
                                    >
                                        <b-button
                                            block
                                            v-b-toggle.accordion-2-5
                                            variant="white"
                                            class="border-0 text-left"
                                        >
                                            <span class="when-opened">
                                                <i class="fas fa-chevron-down text-success"></i>
                                            </span>
                                            <span class="when-closed">
                                                <i class="fas fa-chevron-right text-success"></i>
                                            </span>
                                            <span class="font-weight-bolder">
                                                What is the 'Ladder Method' / 'Avalanche Method'?
                                            </span>
                                        </b-button>
                                    </b-card-header>
                                    <b-collapse
                                        id="accordion-2-5"
                                        accordion="finding-accordion"
                                        role="tabpanel"
                                    >
                                        <b-card-body>
                                            <b-card-text>
                                                The
                                                <span class="text-success font-weight-bolder"
                                                    >Ladder Method</span
                                                >, also known as the
                                                <span class="text-success font-weight-bolder"
                                                    >Avalanche Method</span
                                                >, is a method of gaining explosive growth on
                                                Instagram.
                                            </b-card-text>
                                            <b-card-text>
                                                Simply put, the Ladder Method involves selecting:
                                                <ul>
                                                    <li>
                                                        10 small hashtags, i.e. hashtags with a
                                                        smaller post count
                                                    </li>
                                                    <li>
                                                        10 medium hashtags, i.e. hashtags with a
                                                        medium post count
                                                    </li>
                                                    <li>
                                                        10 big hashtags, i.e. hashtags with a big
                                                        post count
                                                    </li>
                                                </ul>
                                            </b-card-text>
                                            <b-card-text>
                                                Using this strategy, your posts will cause an
                                                <span class="text-success font-weight-bolder"
                                                    >Avalanche</span
                                                >: once you start ranking in the 'top posts' section
                                                of the smaller hashtags, your post will get a boost
                                                in likes and engagement, which will help you rank in
                                                the 'top posts' section of the medium hashtags, etc.
                                            </b-card-text>
                                            <b-card-text>
                                                This strategy enables you rank high in the 'top
                                                posts' section of larger hashtags that you wouldn't
                                                necessarily be able to rank on in normal
                                                circumstances. You're effectively
                                                <span class="text-success font-weight-bolder"
                                                    >climbing the Ladder</span
                                                >.
                                            </b-card-text>
                                        </b-card-body>
                                    </b-collapse>
                                </b-card>

                                <b-card no-body class="mb-1 border-0">
                                    <b-card-header
                                        header-tag="header"
                                        class="p-1 border-0"
                                        role="tab"
                                    >
                                        <b-button
                                            block
                                            v-b-toggle.accordion-2-7
                                            variant="white"
                                            class="border-0 text-left"
                                        >
                                            <span class="when-opened">
                                                <i class="fas fa-chevron-down text-success"></i>
                                            </span>
                                            <span class="when-closed">
                                                <i class="fas fa-chevron-right text-success"></i>
                                            </span>
                                            <span class="font-weight-bolder">
                                                How many hashtags should I use?
                                            </span>
                                        </b-button>
                                    </b-card-header>
                                    <b-collapse
                                        id="accordion-2-7"
                                        accordion="finding-accordion"
                                        role="tabpanel"
                                    >
                                        <b-card-body>
                                            <b-card-text>
                                                Hashtastic recommends using between
                                                <span class="text-success font-weight-bolder"
                                                    >25 and 30</span
                                                >
                                                hashtags in order to maximise your chances of
                                                ranking on those hashtags, as well as increasing the
                                                effectiveness of the Ladder strategy.
                                            </b-card-text>
                                        </b-card-body>
                                    </b-collapse>
                                </b-card>

                                <b-card no-body class="mb-1 border-0">
                                    <b-card-header
                                        header-tag="header"
                                        class="p-1 border-0"
                                        role="tab"
                                    >
                                        <b-button
                                            block
                                            v-b-toggle.accordion-2-8
                                            variant="white"
                                            class="border-0 text-left"
                                        >
                                            <span class="when-opened">
                                                <i class="fas fa-chevron-down text-success"></i>
                                            </span>
                                            <span class="when-closed">
                                                <i class="fas fa-chevron-right text-success"></i>
                                            </span>
                                            <span class="font-weight-bolder">
                                                Can I just re-use the same hashtags over and over
                                                again?
                                            </span>
                                        </b-button>
                                    </b-card-header>
                                    <b-collapse
                                        id="accordion-2-8"
                                        accordion="finding-accordion"
                                        role="tabpanel"
                                    >
                                        <b-card-body>
                                            <b-card-text>
                                                We
                                                <span class="text-danger font-weight-bolder"
                                                    >do not</span
                                                >
                                                recommend re-using the exact same hashtag set on
                                                multiple posts. Instagram sometimes identifies this
                                                behaviour as spam-like, and may reduce the reach of
                                                your posts.
                                            </b-card-text>
                                        </b-card-body>
                                    </b-collapse>
                                </b-card>

                                <b-card no-body class="mb-1 border-0">
                                    <b-card-header
                                        header-tag="header"
                                        class="p-1 border-0"
                                        role="tab"
                                    >
                                        <b-button
                                            block
                                            v-b-toggle.accordion-2-9
                                            variant="white"
                                            class="border-0 text-left"
                                        >
                                            <span class="when-opened">
                                                <i class="fas fa-chevron-down text-success"></i>
                                            </span>
                                            <span class="when-closed">
                                                <i class="fas fa-chevron-right text-success"></i>
                                            </span>
                                            <span class="font-weight-bolder">
                                                Should I put my hashtags in the post description or
                                                in the comments?
                                            </span>
                                        </b-button>
                                    </b-card-header>
                                    <b-collapse
                                        id="accordion-2-9"
                                        accordion="finding-accordion"
                                        role="tabpanel"
                                    >
                                        <b-card-body>
                                            <b-card-text>
                                                We recommend putting your hashtags in the
                                                <span class="text-success font-weight-bolder"
                                                    >description</span
                                                >
                                                of your post, and not in the comments.
                                            </b-card-text>
                                            <b-card-text>
                                                If you accidentally use banned hashtags in your post
                                                description, Instagram may remove your entire
                                                description from your post. This way you know you've
                                                used banned hashtags and you can try posting your
                                                photo again with a different set of hashtags.
                                            </b-card-text>
                                            <b-card-text>
                                                However, if you use banned hashtags in the comment
                                                section, Instagram won't remove the comment but will
                                                simply shadow-ban your post.
                                            </b-card-text>
                                            <b-card-text>
                                                Putting your hashtags in the description gives you
                                                more control and a better insight into if you've
                                                accidentally used a banned hashtag.
                                            </b-card-text>
                                        </b-card-body>
                                    </b-collapse>
                                </b-card>

                                <b-card no-body class="mb-1 border-0">
                                    <b-card-header
                                        header-tag="header"
                                        class="p-1 border-0"
                                        role="tab"
                                    >
                                        <b-button
                                            block
                                            v-b-toggle.accordion-2-6
                                            variant="white"
                                            class="border-0 text-left"
                                        >
                                            <span class="when-opened">
                                                <i class="fas fa-chevron-down text-success"></i>
                                            </span>
                                            <span class="when-closed">
                                                <i class="fas fa-chevron-right text-success"></i>
                                            </span>
                                            <span class="font-weight-bolder">
                                                I can't find the hashtags I want...
                                            </span>
                                        </b-button>
                                    </b-card-header>
                                    <b-collapse
                                        id="accordion-2-6"
                                        accordion="finding-accordion"
                                        role="tabpanel"
                                    >
                                        <b-card-body>
                                            <b-card-text>
                                                Hashtastic has a database containing
                                                <span class="text-success font-weight-bolder"
                                                    >millions of hashtags</span
                                                >, however sometimes you may need to query a hashtag
                                                that isn't in Hashtastic's database.
                                            </b-card-text>
                                            <b-card-text>
                                                If this happens, Hashtastic logs the hashtag it
                                                couldn't find, and then immediately searches
                                                Instagram for that hashtag, and any hashtag that
                                                looks similar, in order to get the results back to
                                                you. This means
                                                <span class="text-primary font-weight-bolder"
                                                    >Hashtastic is constantly growing and expanding
                                                    its hashtag database</span
                                                >, covering more and more niches and topics.
                                            </b-card-text>
                                            <b-card-text>
                                                Usually your new hashtags are available within 10-15
                                                minutes.
                                            </b-card-text>
                                        </b-card-body>
                                    </b-collapse>
                                </b-card>
                            </div>
                        </div>

                        <!-- Saving Hashtags -->
                        <div v-if="currentPanel == 'saving'">
                            <div role="tablist">
                                <b-card no-body class="mb-1 border-0">
                                    <b-card-header
                                        header-tag="header"
                                        class="p-1 border-0"
                                        role="tab"
                                    >
                                        <b-button
                                            block
                                            v-b-toggle.accordion-3-1
                                            variant="white"
                                            class="border-0 text-left"
                                        >
                                            <span class="when-opened">
                                                <i class="fas fa-chevron-down text-success"></i>
                                            </span>
                                            <span class="when-closed">
                                                <i class="fas fa-chevron-right text-success"></i>
                                            </span>
                                            <span class="font-weight-bolder">
                                                Can Hashtastic store hashtags selections for me?
                                            </span>
                                        </b-button>
                                    </b-card-header>
                                    <b-collapse
                                        id="accordion-3-1"
                                        visible
                                        accordion="saving-accordion"
                                        role="tabpanel"
                                    >
                                        <b-card-body>
                                            <b-card-text>
                                                <span class="text-success font-weight-bolder">
                                                    Of course!
                                                </span>
                                                Once you've found the hashtags you want, simply
                                                click on the big 'Save Hashtag Set' button in order
                                                to save your selection directly in the app. Once
                                                they are saved you can access them from the
                                                <router-link
                                                    to="/myhashtags"
                                                    class="text-primary font-weight-bolder"
                                                    >My Hashtags</router-link
                                                >
                                                section of Hashtastic.
                                            </b-card-text>
                                            <b-card-text>
                                                Alternatively, you can go directly to
                                                <router-link
                                                    to="/myhashtags"
                                                    class="text-primary font-weight-bolder"
                                                    >My Hashtags</router-link
                                                >
                                                and manually enter, edit, and scan as many hashtags
                                                as you want straight from there, it's up to you!
                                            </b-card-text>
                                        </b-card-body>
                                    </b-collapse>
                                </b-card>

                                <b-card no-body class="mb-1 border-0">
                                    <b-card-header
                                        header-tag="header"
                                        class="p-1 border-0"
                                        role="tab"
                                    >
                                        <b-button
                                            block
                                            v-b-toggle.accordion-3-2
                                            variant="white"
                                            class="border-0 text-left"
                                        >
                                            <span class="when-opened">
                                                <i class="fas fa-chevron-down text-success"></i>
                                            </span>
                                            <span class="when-closed">
                                                <i class="fas fa-chevron-right text-success"></i>
                                            </span>
                                            <span class="font-weight-bolder">
                                                How many Hashtag sets can I save on Hashtastic?
                                            </span>
                                        </b-button>
                                    </b-card-header>
                                    <b-collapse
                                        id="accordion-3-2"
                                        accordion="saving-accordion"
                                        role="tabpanel"
                                    >
                                        <b-card-body>
                                            <b-card-text>
                                                As many as you like! Most of our competitors have a
                                                hard limit on the number of hashtags you can save,
                                                <span class="text-success font-weight-bolder">
                                                    we don't </span
                                                >.
                                            </b-card-text>
                                        </b-card-body>
                                    </b-collapse>
                                </b-card>
                            </div>
                        </div>

                        <!-- Campaigns -->
                        <div v-if="currentPanel == 'campaigns'">
                            <div role="tablist">
                                <b-card no-body class="mb-1 border-0">
                                    <b-card-header
                                        header-tag="header"
                                        class="p-1 border-0"
                                        role="tab"
                                    >
                                        <b-button
                                            block
                                            v-b-toggle.accordion-4-1
                                            variant="white"
                                            class="border-0 text-left"
                                        >
                                            <span class="when-opened">
                                                <i class="fas fa-chevron-down text-success"></i>
                                            </span>
                                            <span class="when-closed">
                                                <i class="fas fa-chevron-right text-success"></i>
                                            </span>
                                            <span class="font-weight-bolder">
                                                What is a Hashtag Performance Campaign?
                                            </span>
                                        </b-button>
                                    </b-card-header>
                                    <b-collapse
                                        id="accordion-4-1"
                                        visible
                                        accordion="camp-accordion"
                                        role="tabpanel"
                                    >
                                        <b-card-body>
                                            <b-card-text>
                                                Hashtastic's
                                                <span class="text-success font-weight-bolder">
                                                    Hashtag Performance Campaign
                                                </span>
                                                is the ultimate solution to test out hashtag
                                                strategies.
                                            </b-card-text>
                                            <b-card-text>
                                                Once you've created your
                                                <router-link
                                                    to="/mycampaigns"
                                                    class="text-primary font-weight-bolder"
                                                >
                                                    first Hashtag Performance Campaign
                                                </router-link>
                                                for one of your Instagram Accounts, Hashtastic will
                                                then log and monitor all of your future posts,
                                                identifying all the hashtags that were used, as well
                                                as all the instances where your post ranked in the
                                                'top posts' section of a given hashtag.
                                            </b-card-text>
                                            <b-card-text>
                                                This means you can precisly identify which hashtags
                                                are providing results to you, and which ones arent,
                                                enabling you to fine-tune your hashtag strategy with
                                                ease.
                                            </b-card-text>
                                        </b-card-body>
                                    </b-collapse>
                                </b-card>

                                <b-card no-body class="mb-1 border-0">
                                    <b-card-header
                                        header-tag="header"
                                        class="p-1 border-0"
                                        role="tab"
                                    >
                                        <b-button
                                            block
                                            v-b-toggle.accordion-4-2
                                            variant="white"
                                            class="border-0 text-left"
                                        >
                                            <span class="when-opened">
                                                <i class="fas fa-chevron-down text-success"></i>
                                            </span>
                                            <span class="when-closed">
                                                <i class="fas fa-chevron-right text-success"></i>
                                            </span>
                                            <span class="font-weight-bolder">
                                                How do I use the Hashtag Campaign Module?
                                            </span>
                                        </b-button>
                                    </b-card-header>
                                    <b-collapse
                                        id="accordion-4-2"
                                        accordion="camp-accordion"
                                        role="tabpanel"
                                    >
                                        <b-card-body>
                                            <b-card-text>
                                                <span class="text-success font-weight-bolder"
                                                    >Easy!
                                                </span>
                                                Head over to the
                                                <router-link
                                                    to="/mycampaigns"
                                                    class="text-primary font-weight-bolder"
                                                >
                                                    Hashtag Performance Campaign module
                                                </router-link>
                                                of Hashtastic and simply add the accounts you want
                                                Hashtastic to monitor. Hashtastic will then take
                                                care of all the rest automatically.
                                            </b-card-text>
                                        </b-card-body>
                                    </b-collapse>
                                </b-card>

                                <b-card no-body class="mb-1 border-0">
                                    <b-card-header
                                        header-tag="header"
                                        class="p-1 border-0"
                                        role="tab"
                                    >
                                        <b-button
                                            block
                                            v-b-toggle.accordion-4-3
                                            variant="white"
                                            class="border-0 text-left"
                                        >
                                            <span class="when-opened">
                                                <i class="fas fa-chevron-down text-success"></i>
                                            </span>
                                            <span class="when-closed">
                                                <i class="fas fa-chevron-right text-success"></i>
                                            </span>
                                            <span class="font-weight-bolder">
                                                How do I interpret the results of a Campaign?
                                            </span>
                                        </b-button>
                                    </b-card-header>
                                    <b-collapse
                                        id="accordion-4-3"
                                        accordion="camp-accordion"
                                        role="tabpanel"
                                    >
                                        <b-card-body>
                                            <b-card-text>
                                                Once you've created your
                                                <router-link
                                                    to="/mycampaigns"
                                                    class="text-primary font-weight-bolder"
                                                >
                                                    first Hashtag Performance Campaign </router-link
                                                >, Hashtastic will automatically add all your future
                                                posts to your Campaign and display them for you, as
                                                well as all the results:
                                                <ul>
                                                    <li>
                                                        <span
                                                            class="text-primary font-weight-bolder"
                                                        >
                                                            Ranked Hashtags
                                                        </span>
                                                        - Hashtastic logs all the instances where
                                                        your post appeared in the 'top posts'
                                                        section of each hashtag that was used on
                                                        your post, as well as how high you ended up
                                                        ranking.
                                                    </li>
                                                    <li>
                                                        <span
                                                            class="text-primary font-weight-bolder"
                                                        >
                                                            Unranked Hashtags
                                                        </span>
                                                        - These are the hashtags where your post
                                                        didn't rank. You should try removing these
                                                        or replacing them with other, better
                                                        hashtags. Since you didn't rank on them they
                                                        didn't provide you with any engagement or
                                                        reach.
                                                    </li>
                                                    <li>
                                                        <span
                                                            class="text-primary font-weight-bolder"
                                                        >
                                                            Engagement Statistics
                                                        </span>
                                                        - Hashtastic summarises the engagement on
                                                        your post and compares it to your average
                                                        engagement to give you a quick view of how
                                                        well this post is doing compared to other
                                                        posts.
                                                    </li>
                                                    <li>
                                                        <span
                                                            class="text-primary font-weight-bolder"
                                                        >
                                                            Summary of Hashtag Performance
                                                        </span>
                                                        - Hashtastic summarises the performance of
                                                        all the hashtags you've ever used, giving
                                                        you a high-level view of how many times you
                                                        ranked on each, how many times each hashtag
                                                        was used, and more, giving you the
                                                        opportunity to quickly select the top
                                                        performers for your next post
                                                    </li>
                                                </ul>
                                                If you feel like there are metrics or features that
                                                are missing, we would love to hear from you! Head
                                                over to the
                                                <router-link
                                                    to="/support"
                                                    class="text-primary font-weight-bolder"
                                                >
                                                    Support page
                                                </router-link>
                                                and let us know all about it.
                                            </b-card-text>
                                        </b-card-body>
                                    </b-collapse>
                                </b-card>

                                <b-card no-body class="mb-1 border-0">
                                    <b-card-header
                                        header-tag="header"
                                        class="p-1 border-0"
                                        role="tab"
                                    >
                                        <b-button
                                            block
                                            v-b-toggle.accordion-4-4
                                            variant="white"
                                            class="border-0 text-left"
                                        >
                                            <span class="when-opened">
                                                <i class="fas fa-chevron-down text-success"></i>
                                            </span>
                                            <span class="when-closed">
                                                <i class="fas fa-chevron-right text-success"></i>
                                            </span>
                                            <span class="font-weight-bolder">
                                                Hashtastic said I ranked on a hashtag but I can't
                                                see it?
                                            </span>
                                        </b-button>
                                    </b-card-header>
                                    <b-collapse
                                        id="accordion-4-4"
                                        accordion="camp-accordion"
                                        role="tabpanel"
                                    >
                                        <b-card-body>
                                            <b-card-text>
                                                Hashtastic monitors all the hashtags that your posts
                                                have used, and logs any time a post has ranked on
                                                one of those hashtags.
                                            </b-card-text>
                                            <b-card-text>
                                                We then display the
                                                <span class="text-success font-weight-bolder"
                                                    >best rank</span
                                                >
                                                that your post obtained. This isn't your current
                                                rank, it is your best rank.
                                            </b-card-text>
                                            <b-card-text>
                                                Posts will naturally rise in hashtag ranking and
                                                then fall when new posts are submitted or if the
                                                competition is really strong. So if Hashtastic
                                                indicates that your post ranked #3 on a given
                                                hashtag, this means that the best position you ever
                                                reached with that post was position #3 (before
                                                dropping back down).
                                            </b-card-text>
                                        </b-card-body>
                                    </b-collapse>
                                </b-card>

                                <b-card no-body class="mb-1 border-0">
                                    <b-card-header
                                        header-tag="header"
                                        class="p-1 border-0"
                                        role="tab"
                                    >
                                        <b-button
                                            block
                                            v-b-toggle.accordion-4-5
                                            variant="white"
                                            class="border-0 text-left"
                                        >
                                            <span class="when-opened">
                                                <i class="fas fa-chevron-down text-success"></i>
                                            </span>
                                            <span class="when-closed">
                                                <i class="fas fa-chevron-right text-success"></i>
                                            </span>
                                            <span class="font-weight-bolder">
                                                Why don't my old posts appear?
                                            </span>
                                        </b-button>
                                    </b-card-header>
                                    <b-collapse
                                        id="accordion-4-5"
                                        accordion="camp-accordion"
                                        role="tabpanel"
                                    >
                                        <b-card-body>
                                            <b-card-text>
                                                In order to provide our users with the most
                                                up-to-date and reliable results, Hashtastic needs to
                                                monitor posts from the second they are posted. Older
                                                posts may have already gone through their lifecycle
                                                and no longer rank on the 'top posts' section of a
                                                hashtag, meaning it is impossible to reliably
                                                analyse their performance. This is why we choose to
                                                log future posts rather than pre-existing posts.
                                            </b-card-text>
                                            <b-card-text>
                                                Once your Campaign is started however, we won't miss
                                                a single post!
                                            </b-card-text>
                                        </b-card-body>
                                    </b-collapse>
                                </b-card>

                                <b-card no-body class="mb-1 border-0">
                                    <b-card-header
                                        header-tag="header"
                                        class="p-1 border-0"
                                        role="tab"
                                    >
                                        <b-button
                                            block
                                            v-b-toggle.accordion-4-6
                                            variant="white"
                                            class="border-0 text-left"
                                        >
                                            <span class="when-opened">
                                                <i class="fas fa-chevron-down text-success"></i>
                                            </span>
                                            <span class="when-closed">
                                                <i class="fas fa-chevron-right text-success"></i>
                                            </span>
                                            <span class="font-weight-bolder">
                                                How many Campaigns can I run at the same time?
                                            </span>
                                        </b-button>
                                    </b-card-header>
                                    <b-collapse
                                        id="accordion-4-6"
                                        accordion="camp-accordion"
                                        role="tabpanel"
                                    >
                                        <b-card-body>
                                            <b-card-text>
                                                The number of Hashtag Performance Campaigns you can
                                                run depends on your Subscription Tier. Head over to
                                                the
                                                <router-link
                                                    to="/subscribe"
                                                    class="text-primary font-weight-bolder"
                                                >
                                                    Subscribe Page
                                                </router-link>
                                                to order a package with the number of Campaigns you
                                                need.
                                            </b-card-text>
                                        </b-card-body>
                                    </b-collapse>
                                </b-card>

                                <b-card no-body class="mb-1 border-0">
                                    <b-card-header
                                        header-tag="header"
                                        class="p-1 border-0"
                                        role="tab"
                                    >
                                        <b-button
                                            block
                                            v-b-toggle.accordion-4-7
                                            variant="white"
                                            class="border-0 text-left"
                                        >
                                            <span class="when-opened">
                                                <i class="fas fa-chevron-down text-success"></i>
                                            </span>
                                            <span class="when-closed">
                                                <i class="fas fa-chevron-right text-success"></i>
                                            </span>
                                            <span class="font-weight-bolder">
                                                Why can't I delete my Campaign?
                                            </span>
                                        </b-button>
                                    </b-card-header>
                                    <b-collapse
                                        id="accordion-4-7"
                                        accordion="camp-accordion"
                                        role="tabpanel"
                                    >
                                        <b-card-body>
                                            <b-card-text>
                                                In order to provide the most accurate results
                                                Hashtag Performance Campaigns have to run for a
                                                minimum of 5 days before they can be removed. This
                                                also enables us to prevent users from spamming the
                                                system.
                                            </b-card-text>
                                        </b-card-body>
                                    </b-collapse>
                                </b-card>
                            </div>
                        </div>

                        <!-- Subscription -->
                        <div v-if="currentPanel == 'subscription'">
                            <div role="tablist">
                                <b-card no-body class="mb-1 border-0">
                                    <b-card-header
                                        header-tag="header"
                                        class="p-1 border-0"
                                        role="tab"
                                    >
                                        <b-button
                                            block
                                            v-b-toggle.accordion-5-1
                                            variant="white"
                                            class="border-0 text-left"
                                        >
                                            <span class="when-opened">
                                                <i class="fas fa-chevron-down text-success"></i>
                                            </span>
                                            <span class="when-closed">
                                                <i class="fas fa-chevron-right text-success"></i>
                                            </span>
                                            <span class="font-weight-bolder">
                                                Does Hashtastic automatically renew my Subscription?
                                            </span>
                                        </b-button>
                                    </b-card-header>
                                    <b-collapse
                                        id="accordion-5-1"
                                        visible
                                        accordion="sub-accordion"
                                        role="tabpanel"
                                    >
                                        <b-card-body>
                                            <b-card-text>
                                                <span class="text-success font-weight-bolder">
                                                    No </span
                                                >, Hashtastic doesn't automatically renew our users
                                                subscriptions. It may mean less money for us, but we
                                                don't want our customers accidentally forgetting
                                                they were subscribed and paying us money they didn't
                                                want to pay us.
                                            </b-card-text>
                                        </b-card-body>
                                    </b-collapse>
                                </b-card>

                                <b-card no-body class="mb-1 border-0">
                                    <b-card-header
                                        header-tag="header"
                                        class="p-1 border-0"
                                        role="tab"
                                    >
                                        <b-button
                                            block
                                            v-b-toggle.accordion-5-2
                                            variant="white"
                                            class="border-0 text-left"
                                        >
                                            <span class="when-opened">
                                                <i class="fas fa-chevron-down text-success"></i>
                                            </span>
                                            <span class="when-closed">
                                                <i class="fas fa-chevron-right text-success"></i>
                                            </span>
                                            <span class="font-weight-bolder">
                                                Can I get a refund?
                                            </span>
                                        </b-button>
                                    </b-card-header>
                                    <b-collapse
                                        id="accordion-5-2"
                                        accordion="sub-accordion"
                                        role="tabpanel"
                                    >
                                        <b-card-body>
                                            <b-card-text>
                                                If you're not happy with the service, we will
                                                immediately provide you with a refund. Get in touch
                                                with our commercial teams using the
                                                <router-link
                                                    to="/subscribe"
                                                    class="text-primary font-weight-bolder"
                                                >
                                                    Support Form
                                                </router-link>
                                                , and describe exactly why you weren't happy with
                                                the service.
                                            </b-card-text>
                                            <b-card-text>
                                                We are constantly working on improving the service,
                                                and we take negative feedback very seriously.
                                            </b-card-text>
                                        </b-card-body>
                                    </b-collapse>
                                </b-card>

                                <b-card no-body class="mb-1 border-0">
                                    <b-card-header
                                        header-tag="header"
                                        class="p-1 border-0"
                                        role="tab"
                                    >
                                        <b-button
                                            block
                                            v-b-toggle.accordion-5-3
                                            variant="white"
                                            class="border-0 text-left"
                                        >
                                            <span class="when-opened">
                                                <i class="fas fa-chevron-down text-success"></i>
                                            </span>
                                            <span class="when-closed">
                                                <i class="fas fa-chevron-right text-success"></i>
                                            </span>
                                            <span class="font-weight-bolder">
                                                Do you do custom packages / white-labeled versions
                                                of Hashtastic?
                                            </span>
                                        </b-button>
                                    </b-card-header>
                                    <b-collapse
                                        id="accordion-5-3"
                                        accordion="sub-accordion"
                                        role="tabpanel"
                                    >
                                        <b-card-body>
                                            <b-card-text>
                                                We tailor packages and solutions for all of our
                                                clients, including our Enterprise clients. Get in
                                                touch with our sales team at
                                                <span class="text-primary font-weight-bolder">
                                                    support@hashtastic.eu
                                                </span>
                                                and we'll get back to you as soon as possible.
                                            </b-card-text>
                                        </b-card-body>
                                    </b-collapse>
                                </b-card>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- End main card -->

        <div class="row">
            <div class="col-xl-4 gutter-b">
                <div class="card card-custom card-stretch mb-8 mb-lg-0">
                    <div class="card-body">
                        <div class="d-flex p-5">
                            <div class="mr-6">
                                <span class="svg-icon svg-icon-5x svg-icon-primary">
                                    <!--begin::Svg Icon | path:/metronic/themes/metronic/theme/html/demo2/dist/assets/media/svg/icons/Code/Compiling.svg-->
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        xmlns:xlink="http://www.w3.org/1999/xlink"
                                        width="24px"
                                        height="24px"
                                        viewBox="0 0 24 24"
                                        version="1.1"
                                    >
                                        <g
                                            stroke="none"
                                            stroke-width="1"
                                            fill="none"
                                            fill-rule="evenodd"
                                        >
                                            <rect x="0" y="0" width="24" height="24"></rect>
                                            <path
                                                d="M2.56066017,10.6819805 L4.68198052,8.56066017 C5.26776695,7.97487373 6.21751442,7.97487373 6.80330086,8.56066017 L8.9246212,10.6819805 C9.51040764,11.267767 9.51040764,12.2175144 8.9246212,12.8033009 L6.80330086,14.9246212 C6.21751442,15.5104076 5.26776695,15.5104076 4.68198052,14.9246212 L2.56066017,12.8033009 C1.97487373,12.2175144 1.97487373,11.267767 2.56066017,10.6819805 Z M14.5606602,10.6819805 L16.6819805,8.56066017 C17.267767,7.97487373 18.2175144,7.97487373 18.8033009,8.56066017 L20.9246212,10.6819805 C21.5104076,11.267767 21.5104076,12.2175144 20.9246212,12.8033009 L18.8033009,14.9246212 C18.2175144,15.5104076 17.267767,15.5104076 16.6819805,14.9246212 L14.5606602,12.8033009 C13.9748737,12.2175144 13.9748737,11.267767 14.5606602,10.6819805 Z"
                                                fill="#000000"
                                                opacity="0.3"
                                            ></path>
                                            <path
                                                d="M8.56066017,16.6819805 L10.6819805,14.5606602 C11.267767,13.9748737 12.2175144,13.9748737 12.8033009,14.5606602 L14.9246212,16.6819805 C15.5104076,17.267767 15.5104076,18.2175144 14.9246212,18.8033009 L12.8033009,20.9246212 C12.2175144,21.5104076 11.267767,21.5104076 10.6819805,20.9246212 L8.56066017,18.8033009 C7.97487373,18.2175144 7.97487373,17.267767 8.56066017,16.6819805 Z M8.56066017,4.68198052 L10.6819805,2.56066017 C11.267767,1.97487373 12.2175144,1.97487373 12.8033009,2.56066017 L14.9246212,4.68198052 C15.5104076,5.26776695 15.5104076,6.21751442 14.9246212,6.80330086 L12.8033009,8.9246212 C12.2175144,9.51040764 11.267767,9.51040764 10.6819805,8.9246212 L8.56066017,6.80330086 C7.97487373,6.21751442 7.97487373,5.26776695 8.56066017,4.68198052 Z"
                                                fill="#000000"
                                            ></path>
                                        </g></svg
                                    ><!--end::Svg Icon-->
                                </span>
                            </div>
                            <div class="d-flex flex-column">
                                <router-link
                                    to="/subscribe"
                                    class="text-dark text-hover-primary font-weight-bold font-size-h4 mb-3"
                                >
                                    Get Started
                                </router-link>
                                <div class="text-dark-75">
                                    Top up your account with a Premium Subscription and start making
                                    the most out of Hashtastic!
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-xl-4 gutter-b">
                <div class="card card-custom card-stretch mb-8 mb-lg-0">
                    <div class="card-body">
                        <div class="d-flex p-5">
                            <div class="mr-6">
                                <span class="svg-icon svg-icon-5x svg-icon-success">
                                    <!--begin::Svg Icon | path:/metronic/themes/metronic/theme/html/demo2/dist/assets/media/svg/icons/Code/Compiling.svg-->
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        xmlns:xlink="http://www.w3.org/1999/xlink"
                                        width="24px"
                                        height="24px"
                                        viewBox="0 0 24 24"
                                        version="1.1"
                                    >
                                        <g
                                            stroke="none"
                                            stroke-width="1"
                                            fill="none"
                                            fill-rule="evenodd"
                                        >
                                            <rect x="0" y="0" width="24" height="24"></rect>
                                            <path
                                                d="M8,3 L8,3.5 C8,4.32842712 8.67157288,5 9.5,5 L14.5,5 C15.3284271,5 16,4.32842712 16,3.5 L16,3 L18,3 C19.1045695,3 20,3.8954305 20,5 L20,21 C20,22.1045695 19.1045695,23 18,23 L6,23 C4.8954305,23 4,22.1045695 4,21 L4,5 C4,3.8954305 4.8954305,3 6,3 L8,3 Z"
                                                fill="#000000"
                                                opacity="0.3"
                                            ></path>
                                            <path
                                                d="M10.875,15.75 C10.6354167,15.75 10.3958333,15.6541667 10.2041667,15.4625 L8.2875,13.5458333 C7.90416667,13.1625 7.90416667,12.5875 8.2875,12.2041667 C8.67083333,11.8208333 9.29375,11.8208333 9.62916667,12.2041667 L10.875,13.45 L14.0375,10.2875 C14.4208333,9.90416667 14.9958333,9.90416667 15.3791667,10.2875 C15.7625,10.6708333 15.7625,11.2458333 15.3791667,11.6291667 L11.5458333,15.4625 C11.3541667,15.6541667 11.1145833,15.75 10.875,15.75 Z"
                                                fill="#000000"
                                            ></path>
                                            <path
                                                d="M11,2 C11,1.44771525 11.4477153,1 12,1 C12.5522847,1 13,1.44771525 13,2 L14.5,2 C14.7761424,2 15,2.22385763 15,2.5 L15,3.5 C15,3.77614237 14.7761424,4 14.5,4 L9.5,4 C9.22385763,4 9,3.77614237 9,3.5 L9,2.5 C9,2.22385763 9.22385763,2 9.5,2 L11,2 Z"
                                                fill="#000000"
                                            ></path>
                                        </g></svg
                                    ><!--end::Svg Icon-->
                                </span>
                            </div>
                            <div class="d-flex flex-column">
                                <router-link
                                    to="/search"
                                    class="text-dark text-hover-primary font-weight-bold font-size-h4 mb-3"
                                >
                                    Find Hashtags
                                </router-link>
                                <div class="text-dark-75">
                                    Looking for new Hashtags? Start here.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-xl-4 gutter-b">
                <div class="card card-custom card-stretch mb-8 mb-lg-0">
                    <div class="card-body">
                        <div class="d-flex p-5">
                            <div class="mr-6">
                                <span class="svg-icon svg-icon-5x svg-icon-danger">
                                    <!--begin::Svg Icon | path:/metronic/themes/metronic/theme/html/demo2/dist/assets/media/svg/icons/Code/Compiling.svg-->
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        xmlns:xlink="http://www.w3.org/1999/xlink"
                                        width="24px"
                                        height="24px"
                                        viewBox="0 0 24 24"
                                        version="1.1"
                                    >
                                        <g
                                            stroke="none"
                                            stroke-width="1"
                                            fill="none"
                                            fill-rule="evenodd"
                                        >
                                            <rect x="0" y="0" width="24" height="24"></rect>
                                            <path
                                                d="M6,9 L6,15 C6,16.6568542 7.34314575,18 9,18 L15,18 L15,18.8181818 C15,20.2324881 14.2324881,21 12.8181818,21 L5.18181818,21 C3.76751186,21 3,20.2324881 3,18.8181818 L3,11.1818182 C3,9.76751186 3.76751186,9 5.18181818,9 L6,9 Z M17,16 L17,10 C17,8.34314575 15.6568542,7 14,7 L8,7 L8,6.18181818 C8,4.76751186 8.76751186,4 10.1818182,4 L17.8181818,4 C19.2324881,4 20,4.76751186 20,6.18181818 L20,13.8181818 C20,15.2324881 19.2324881,16 17.8181818,16 L17,16 Z"
                                                fill="#000000"
                                                fill-rule="nonzero"
                                                opacity="0.3"
                                            ></path>
                                            <path
                                                d="M9.27272727,9 L13.7272727,9 C14.5522847,9 15,9.44771525 15,10.2727273 L15,14.7272727 C15,15.5522847 14.5522847,16 13.7272727,16 L9.27272727,16 C8.44771525,16 8,15.5522847 8,14.7272727 L8,10.2727273 C8,9.44771525 8.44771525,9 9.27272727,9 Z"
                                                fill="#000000"
                                            ></path>
                                        </g></svg
                                    ><!--end::Svg Icon-->
                                </span>
                            </div>
                            <div class="d-flex flex-column">
                                <router-link
                                    to="/mycampaigns"
                                    class="text-dark text-hover-primary font-weight-bold font-size-h4 mb-3"
                                >
                                    Hashtag Performance Campaigns
                                </router-link>
                                <div class="text-dark-75">
                                    Monitor how well each individual hashtags you use are performing
                                    on your posts!
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import "~bootstrap-vue/dist/bootstrap-vue.css";
</style>
<style scoped>
.something {
    font-size: 1.2rem;
    padding: 0 1.1rem;
    list-style: none;
    color: #9492a1;
    font-weight: 500;
}

.lisomething {
    padding: 0.65rem 0;
    margin: 0.25rem 0;
}
.lisomething:hover {
    background-color: #f7f8fa;
    color: #366cf3 !important;
    cursor: pointer;
    -webkit-transition: background-color 0.5s;
    transition: background-color 0.5s;
}

.lisomething a {
    padding-left: 0.65rem;
    margin-left: 3px;
    font-size: 1.2rem;
    padding: 0 1.1rem;
}

.something > .active {
    color: #48465b;
    margin-left: 0;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
}

.something > .active a {
    border-left: 3px solid #366cf3;
    -webkit-transition: background-color 0.5s;
    transition: background-color 0.5s;
}
.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
    display: none;
}
</style>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import axios from "axios";
import PagePreloader from "@/view/content/Custom/PagePreloader.vue";
// Components
import CustomAnnouncements from "@/view/content/Custom/CustomAnnouncements.vue";
//    import ClipboardJS from "clipboard";
//    window.ClipboardJS = ClipboardJS;

export default {
    name: "FAQPage",
    components: {
        PagePreloader,
        CustomAnnouncements,
    },
    data() {
        return {
            // Preloaders
            pageIsLoaded: false,

            // Displayers
            currentPanel: "about",

            // Error management
            errors: [],

            // Modals
        };
    },

    methods: {
        // First method here
        setPanel(item) {
            if (item != this.currentPanel) {
                this.currentPanel = "";
                setTimeout(() => {
                    this.currentPanel = item;
                }, 100);
            }
        },
    },

    mounted() {
        // Set page preloader
        this.pageIsLoaded = true;
        // Set breadcrumb
        this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Frequently Asked Questions", route: "FAQ" },
        ]);
    },
};
</script>
